module.exports = __webpack_public_path__ + "img/WEBP.4615e92f.png";